'use strict';

var addInflection = require('./addInflection'),
    buildAcronymReg = require('./buildAcronymReg');

function addAcronym(str) {
  addInflection('acronyms', str, str);
  addInflection('acronyms', str.toLowerCase(), str);
  buildAcronymReg();
}

module.exports = addAcronym;